import React from 'react'
import ReactDOM from 'react-dom'
import { App } from './App'
import { ThemeProvider } from 'styled-components'
import { theme } from './theme'
import { GlobalStyle, Styler } from './global-style'

const root = document.getElementById('generic-search-module-root')

ReactDOM.render(
  <ThemeProvider theme={theme}>
    <GlobalStyle />
    <Styler>
      <App
        endpoint={root?.dataset?.['endpoint'] ?? '/umbraco/surface/SupportSite/ArticleSearch'}
        resultsPerPage={parseInt(root?.dataset?.['resultsPerPage'] ?? '5', 10)}
        initialResults={parseInt(root?.dataset?.['initialResults'] ?? '5', 10)}
        hideFilter={root?.dataset?.['hideFilter'] === 'true' ?? false}
        hideResultsHeader={root?.dataset?.['hideResultsHeader'] === 'true' ?? false}
        initialTypeFilter={
          root?.dataset?.['initialTypeFilter'] !== undefined
            ? parseInt(root?.dataset?.['initialTypeFilter'], 10)
            : undefined
        }
      />
    </Styler>
  </ThemeProvider>,
  root
)
